import { List, Record } from "immutable";
import { ApprovalAlgorithmRuleModel, type IApprovalAlgorithmRuleSchema } from "models/ApprovalAlgorithmRuleModel";
import { removeRedundantSpaces } from "utils/strings";

const defaults = {
  bundlesInUseCount: null as null | number,
  createdAt: null as null | string,
  id: "",
  isDeleted: false,
  name: "",
  rolesInUseCount: null as null | number,
  rules: null as List<ApprovalAlgorithmRuleModel> | null,
};

export interface IApprovalAlgorithmSchema {
  id: null | string;
  name: string;
  rules: IApprovalAlgorithmRuleSchema[];
}

export class ApprovalAlgorithmModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown) {
    const { bundlesInUseCount, createdAt, id, isDeleted, name, rolesInUseCount, rules } =
      data as typeof defaults;

    return new ApprovalAlgorithmModel({
      bundlesInUseCount,
      createdAt,
      id,
      isDeleted,
      name,
      rolesInUseCount,
      rules: rules ? List(rules.map((rule) => ApprovalAlgorithmRuleModel.fromServerData(rule))) : null,
    });
  }

  toServerData(): IApprovalAlgorithmSchema {
    const { id, name, rules } = this;
    return {
      id,
      name: removeRedundantSpaces(name),
      rules: rules ? rules.map((rule) => rule.toServerData()).toArray() : [],
    };
  }
}
